import { render, staticRenderFns } from "./SendPostEmail.vue?vue&type=template&id=2201fa00&scoped=true&"
import script from "./SendPostEmail.vue?vue&type=script&lang=js&"
export * from "./SendPostEmail.vue?vue&type=script&lang=js&"
import style0 from "./SendPostEmail.vue?vue&type=style&index=0&id=2201fa00&scoped=true&lang=scss&"
import style1 from "../../Auth/AuthModal/AuthModal.scss?vue&type=style&index=1&id=2201fa00&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2201fa00",
  null
  
)

export default component.exports